import React, { useRef, useState, useEffect } from "react";
import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import { authService } from "../service/AuthService";
import {
  SubscriptionType,
  Transporter,
} from "../interfaces/transporters.interface";
import { Button } from "primereact/button";

const ModernHeader = () => {
  const history = useHistory();
  const [, , removeCookie] = useCookies(["Authorization"]);
  const [user, setUser] = useState<Transporter | null>(null);
  const menuRef = useRef<Menu>(null);

  useEffect(() => {
    const fetchUser = () => {
      const currentUser = authService.getUser();
      setUser(currentUser);
    };

    fetchUser();

    // Set up an interval to check for user updates
    const intervalId = setInterval(fetchUser, 5000); // Check every 5 seconds

    return () => clearInterval(intervalId); // Clean up on component unmount
  }, []);

  const handleLogout = async () => {
    try {
      await authService.logOut();
      localStorage.clear();
      removeCookie("Authorization");
      history.push("/");
    } catch (err) {
      console.error(err);
      localStorage.clear();
      removeCookie("Authorization");
      history.push("/");
    }
  };

  const handleUpgradeClick = () => {
    history.push('/subscription');
  };

  const getInitial = () => {
    if (user && user.name) {
      return user.name.charAt(0).toUpperCase();
    }
    return "U";
  };

  const getUserName = () => {
    if (user && user.name) {
      return user.name;
    }
    if (user && user.lastName) {
      return user.lastName;
    }
    return "Utilisateur";
  };
  const getCompanyName = () => {
    if (user && user.companyName) {
      return user.companyName;
    }
    return "Transporteur";
  };
  const menuItems = [
    {
      label: "Déconnexion",
      icon: "pi pi-sign-out",
      command: handleLogout,
    },
  ];

  return (
    <div className="flex justify-end gap-6 items-center bg-slate-50 py-4 px-8">
      {user?.subscriptionType !== SubscriptionType.PAID && <Button
        onClick={handleUpgradeClick}
        className="flex items-center bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white px-4 py-2 rounded-lg transition-all duration-300 border-none outline-none font-sans font-medium"
      >
        <i className="ph-bold ph-star mr-2"></i>
        Passer Premium
      </Button>}
      <div className="flex items-center">
        <Menu model={menuItems} popup ref={menuRef} />
        <div
          className="flex items-center cursor-pointer relative"
          onClick={(e) => menuRef.current?.toggle(e)}
        >
          <Avatar
            image={user?.logo || undefined}
            label={user?.logo ? undefined : getInitial()}
            shape="circle"
            className={`mr-3 relative ${
              user?.subscriptionType === SubscriptionType.PAID
                ? "outline outline-[3px] outline-yellow-500"
                : user?.subscriptionType === SubscriptionType.AFFILIATE
                ? "outline outline-[3px] outline-green-500"
                : ""
            }`}
            size="large"
          >
            {user && user.subscriptionType === SubscriptionType.PAID && (
              <i className="ph-fill ph-crown absolute -bottom-0.5 -right-1 text-yellow-400 text-base bg-slate-800 rounded-full leading-none p-0.5 outline outline-2 outline-yellow-500" title="Abonné" />
            )}
            {user && user.subscriptionType === SubscriptionType.AFFILIATE && (
              <i className="ph-fill ph-network absolute -bottom-0.5 -right-1 text-green-400 text-xs bg-slate-800 rounded-full leading-none p-1 outline outline-2 outline-green-500" title="Affilié"/>
            )}
          </Avatar>
          <div className="flex flex-col">
            <span className="font-semibold">{getUserName()}</span>
            <span className="text-sm text-gray-400">{getCompanyName()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModernHeader;
